import { ConnectTransportOptions } from '@bufbuild/connect-web';
import {
  lmsTransportWithLogoutHandler,
  ResponseStatusCodeFunction,
} from './transports';
import { createPromiseClient } from '@bufbuild/connect';
import { LmsAdminPortalAPIServiceV2 } from '@protos/learning_management/lms.admin.portal.apis_connect';

export const useLmsAdminAPIServiceV2ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LmsAdminPortalAPIServiceV2,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
